import { motion } from 'framer-motion';
import { Building2, Users, Briefcase, Home } from 'lucide-react';
import { AnimatedSection, AnimatedItem, AnimatedCard, staggerContainer } from '@/components/animations';

const audiences = [
  { 
    icon: Home, 
    title: 'Proprietários', 
    desc: 'Que precisam decidir sobre intervenções técnicas no seu elevador.' 
  },
  { 
    icon: Building2, 
    title: 'Condomínios', 
    desc: 'Que enfrentam propostas de modernização ou manutenção complexas.' 
  },
  { 
    icon: Briefcase, 
    title: 'Gestores', 
    desc: 'Que querem reduzir exposição jurídica e fundamentar decisões.' 
  },
  { 
    icon: Users, 
    title: 'Administradores', 
    desc: 'Que necessitam de parecer técnico independente documentado.' 
  },
];

export function TargetAudienceSection() {
  return (
    <section className="py-16 md:py-20 border-t border-border">
      <div className="container">
        <AnimatedSection className="max-w-4xl mx-auto" stagger>
          <AnimatedItem className="text-center mb-10">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/10 text-primary text-sm font-medium mb-6">
              <Users className="w-4 h-4" />
              Para quem é a ElevAdvisor?
            </div>
            <h2 className="text-3xl md:text-4xl font-bold">
              Apoio técnico para quem decide
            </h2>
            <p className="text-lg text-muted-foreground mt-4 max-w-2xl mx-auto">
              A ElevAdvisor ajuda proprietários, gestores e condomínios a tomar decisões técnicas informadas sobre elevadores.
            </p>
          </AnimatedItem>
          
          <motion.div 
            className="grid sm:grid-cols-2 gap-4"
            variants={staggerContainer}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-50px" }}
          >
            {audiences.map((audience, idx) => (
              <AnimatedCard 
                key={idx} 
                className="flex gap-4 p-5 rounded-xl bg-card border border-border hover:border-primary/30 transition-colors"
              >
                <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center shrink-0">
                  <audience.icon className="w-6 h-6 text-primary" />
                </div>
                <div>
                  <h3 className="font-semibold text-foreground mb-1">{audience.title}</h3>
                  <p className="text-sm text-muted-foreground">{audience.desc}</p>
                </div>
              </AnimatedCard>
            ))}
          </motion.div>
        </AnimatedSection>
      </div>
    </section>
  );
}
